const state = {
  isCarousel: true,
  isDisplayModeForced: false,
}

const getters = {
  isCarousel: state => state.isCarousel,
  isDisplayModeForced: state => state.isDisplayModeForced,
}

const mutations = {
	SET_IS_CAROUSEL(state, payload) {
		state.isCarousel = payload;
  },
  FORCE_DISPLAY_MODE(state, payload) {
    state.isDisplayModeForced = payload;
  }
}

const actions = {
	toggleCarousel({ commit, getters }) {
    commit('SET_IS_CAROUSEL', !getters.isCarousel);
    commit('FORCE_DISPLAY_MODE', true);
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
